export default __webpack_public_path__ + "static/media/brutalenragingwound1.a91e7256.png";